
import { mapActions } from "vuex";
import offers from "@/apollo/queries/offer/offers";

export default {
	data() {
		return {
			offers: null
		}
	},
	props: {
		offer: {
			type: Object,
			default: ''
		},
	},
	computed: {
		component() {
			if (this.$device.isTablet) {
				return 'catalog-item-large-mobile'
			} else {
				return this.$device.isMobile ? 'catalog-item-minicard' : 'catalog-item-minicard'
			}

		},
	},
	methods: {
		...mapActions({
			request: 'request'
		}),
		async moreOffers() {
			try {
				await this.offersRequest({
					page: Number(this.offers.current_page + 1),
					limit: 6,
					except_external_id: Number(this.offer.external_id),
					mark_slug_array: [this.offer.mark.slug],
					folder_slug_array: [this.offer.folder.slug],
					generation_slug_array: [this.offer.generation.slug],
					engine_type_id_array: [Number(this.offer.engineType.id)],
					gearbox_id_array: [Number(this.offer.gearbox.id)],
					dateFormat: 'j F Y года.',
				})
			} catch (error) {
				console.log(error)
			}
		},
		async offersRequest(assignVariables) {
			try {
				let response = await this.request({ query: offers, variables: assignVariables })
				if (this.offers) {
					this.offers.data = [...this.offers.data, ...response.data.offers.data]
					this.offers.current_page = response.data.offers.current_page
				} else {
					this.offers = response.data.offers
				}

			} catch (error) {
				console.log(error)
				return this.$nuxt.error({ statusCode: 404, message: '404' })
			}
		},
	},
	async mounted() {
		if (this.offer) {
			try {
				await this.offersRequest({
					page: 0,
					limit: 6,
					except_external_id: this.$device.isMobile ? null : Number(this.offer.external_id),
					mark_slug_array: this.$device.isMobile ? null : [this.offer.mark.slug],
					folder_slug_array: this.$device.isMobile ? null : [this.offer.folder.slug],
					generation_slug_array:  this.$device.isMobile ? null : [this.offer.generation.slug],
					engine_type_id_array:  this.$device.isMobile ? null : [Number(this.offer.engineType.id)],
					gearbox_id_array:  this.$device.isMobile ? null : [Number(this.offer.gearbox.id)],
					dateFormat: 'j F Y года.',
				    price_from: this.$device.isMobile ? this.offer.price - 100000 : null,
                    price_to: this.$device.isMobile ? this.offer.price + 100000 : null,
				})




				this.sd = new swiper.default('.swiper--catalog.swiper', {
					modules: [swiper.Navigation, swiper.Autoplay],
					loop: false,
					// autoplayDisableOnInteraction: true,
					autoplay: false,
					initialSlide: 0,
					// centeredSlides: true,
					activeIndex: 5,
					watchSlidesProgress: true,
					// allowTouchMove: false,
					// centeredSlidesBounds:true,
					// roundLengths: true,

					// centerInsufficientSlides:true,
					// slidesOffsetAfter: this.$refs.asd.getBoundingClientRect().left,
					// cssMode:true,
					// edgeSwipeDetection:'prevent',
					// enabled: false,

					breakpoints: {
						// when window width is >= 320px
						220: {
							slidesPerView: 1.25,
							spaceBetween: 20
						},
						600: {
							slidesPerView: 2,
							spaceBetween: 24,

						}

					},
					navigation: {
						nextEl: '.catalog__list .swiper-button-next',
						prevEl: '.catalog__list .swiper-button-prev',
					},
				});
				this.sd.on('touchStart', (swiper, event) => {
					if (event.target.nodeName === 'IMG') swiper.allowTouchMove = false

				})

				this.sd.on('touchEnd', (swiper, event) => {
					swiper.allowTouchMove = true
				})


			} catch (error) {
				console.log(error)
			}
		}


	}
}
